<script lang="ts">
  import Title from '~/Title.svelte';
  import ArrowLeftIcon from '~icons/feather/arrow-left';
  import { goto } from '$app/navigation';

  const handleBack = () => {
    goto('/');
  };
</script>

<button class="menu-button" style="" on:click={handleBack}>
  <ArrowLeftIcon />
  <Title />
</button>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';

  .menu-button {
    transition: all 0.2s ease;
    text-decoration: none;
    color: currentColor;
    margin-top: -0.5em;
    margin-left: -0.5em;
    margin-bottom: 0;
    background: none;
    border: none;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    border-radius: 999px;
    gap: 0.5em;
    cursor: pointer;
    &:active {
      background-color: color.adjust(
        theme.$tile-default-light,
        $lightness: -20%
      );
      :global(html.dark-mode) & {
        background-color: color.adjust(
          theme.$tile-default-dark,
          $lightness: 20%
        );
      }
    }
    &:hover {
      background-color: color.adjust(
        theme.$tile-default-light,
        $lightness: -10%
      );
      :global(html.dark-mode) & {
        background-color: color.adjust(
          theme.$tile-default-dark,
          $lightness: 10%
        );
      }
    }
  }
</style>
